const MAX_EXTERNAL_URL_LENGTH = 2_048;
const CONTROL_CHARACTER = /[\u0000-\u001f\u007f]/;

/**
 * Converts an untrusted navigation target into a browser-safe HTTPS URL.
 * This is a client navigation boundary, not an SSRF policy: private hosts are
 * allowed because the application never fetches the value server-side.
 */
export function safeExternalHttpsUrl(value: unknown): string | null {
	if (typeof value !== 'string') return null;
	const candidate = value.trim();
	if (!candidate || candidate.length > MAX_EXTERNAL_URL_LENGTH || CONTROL_CHARACTER.test(candidate)) return null;
	try {
		const parsed = new URL(candidate);
		if (parsed.protocol !== 'https:' || !parsed.hostname || parsed.username || parsed.password) return null;
		return parsed.href;
	} catch {
		return null;
	}
}
